import { FC } from 'react'
import { Tooltip, TooltipProps } from 'antd'
import classes from './index.module.css'
import cn from 'classnames'

type TooltipWrapperProps = TooltipProps

const TooltipWrapper: FC<TooltipWrapperProps> = ({
  children,
  className,
  overlayClassName,
  color = 'white',
  ...props
}) => {
  return (
    <Tooltip
      color={color}
      className={cn(classes.tooltip, className)}
      overlayClassName={cn(classes.overlay, overlayClassName)}
      {...props}
    >
      {/* <div></div> */}
      {children}
    </Tooltip>
  )
}

export default TooltipWrapper
